import { gql } from "@apollo/client";

import { CitationFragment } from "./get-ask-ai-session-query";

export default gql`
  ${CitationFragment}
  query getAskAiCitationSourcesQuery(
    $chatSessionId: Int!
    $sourceIds: [String!]!
  ) {
    askAiCitationSources(chatSessionId: $chatSessionId, sourceIds: $sourceIds) {
      ...CitationFragment
    }
  }
`;
